import RoomTypeService from "@/services/RoomTypeService.js";
import Vue from "vue";

// Timer del polling del recàlcul de tarifes calculades. Viu fora de l'state
// perquè no és dada de la vista i no ha de ser reactiu.
let ref_recalc_timer = null;
const REF_RECALC_POLL_MS = 5000;
const REF_RECALC_FINAL_STATUSES = ["done", "partial", "error"];

export const state = {
  // status
  types_mapped_status: 0,
  types_available_status: 0,
  room_rate_ref_period_status: 0,
  // dataset
  types_mapped: [],
  types_available: [],
  room_rate_ref_period: [],
  // recàlcul de tarifes calculades (async)
  ref_recalc_job: null,
  ref_recalc_polling: false
};

export const mutations = {
  SET_DATASET_STATUS(state, { dataset, status }) {
    state[dataset + "_status"] = status;
  },
  GET_DATASET(state, { dataset, data }) {
    state[dataset] = data;
  },
  SET_ROOM_TYPE(state, data) {
    let i = state.types_mapped.findIndex(s => s.id === data.id);
    if (i >= 0) {
      Vue.set(state.types_mapped, i, JSON.parse(JSON.stringify(data)));
    } else {
      state.types_mapped.push(JSON.parse(JSON.stringify(data)));
    }
  },
  DELETE_ROOM_TYPE(state, id) {
    let i = state.types_mapped.findIndex(i => i.id === id);
    if (i >= 0) {
      Vue.delete(state.types_mapped, i);
    }
  },
  SET_ROOM_RATE_PERIODS(state, { id, data }) {
    let i = state.types_mapped.findIndex(s => s.id === id);
    if (i >= 0) {
      Vue.set(state.types_mapped[i], "periods", data);
    }
  },
  HIGHLIGHT_ROOM_TYPE(state, data) {
    let i = state.types_mapped.findIndex(s => s.id === data.id);
    if (i >= 0) {
      for (let j = 0; j < state.types_mapped.length; j++) {
        Vue.set(state.types_mapped[j], "highlighted", 0);
      }
      Vue.set(state.types_mapped[i], "highlighted", 1);
    }
  },
  SET_ROOM_RATE_REF_PERIOD(state, data) {
    state.room_rate_ref_period = data;
  },
  SET_ROOM_RATE_REF_PERIOD_STATUS(state, status) {
    state.room_rate_ref_period_status = status;
  },
  SET_REF_RECALC_JOB(state, job) {
    state.ref_recalc_job = job;
  },
  SET_REF_RECALC_POLLING(state, polling) {
    state.ref_recalc_polling = polling;
  }
};

export const actions = {
  fetchRoomtypeTypesMapped({ commit, rootGetters }, p) {
    const dataset = "types_mapped";
    commit("SET_DATASET_STATUS", { dataset: dataset, status: 1 });

    if (!rootGetters.current_hotel || !rootGetters.current_hotel.id) {
      return null;
    }

    RoomTypeService.getRoomTypesMapped({
      hotel_id: rootGetters.current_hotel.id
    }).then(response => {
      commit("GET_DATASET", { dataset: dataset, data: response.data });
      commit("SET_DATASET_STATUS", { dataset: dataset, status: 2 });
    });
  },
  fetchRoomtypeTypesAvailable({ commit, rootGetters }, p) {
    const dataset = "types_available";
    commit("SET_DATASET_STATUS", { dataset: dataset, status: 1 });

    if (!rootGetters.current_hotel || !rootGetters.current_hotel.id) {
      return null;
    }

    RoomTypeService.getRoomTypesAvailable({
      hotel_id: rootGetters.current_hotel.id
    }).then(response => {
      commit("GET_DATASET", { dataset: dataset, data: response.data });
      commit("SET_DATASET_STATUS", { dataset: dataset, status: 2 });
    });
  },
  generateRoomTypesMappingsFromPms({ commit, rootGetters }, data) {
    return RoomTypeService.generateRoomTypesMappingsFromPms({
      hotel_id: rootGetters.current_hotel.id
    });
  },
  generateRoomTypesMappingsFromChannelManager({ commit, rootGetters }, data) {
    return RoomTypeService.generateRoomTypesMappingsFromChannelManager({
      hotel_id: rootGetters.current_hotel.id
    });
  },
  generateRoomTypesMappingsFromBooking({ commit, rootGetters }, data) {
    return RoomTypeService.generateRoomTypesMappingsFromBooking({
      hotel_id: rootGetters.current_hotel.id
    });
  },
  generateRoomTypesMappingsFromWeb({ commit, rootGetters }, data) {
    return RoomTypeService.generateRoomTypesMappingsFromWeb({
      hotel_id: rootGetters.current_hotel.id
    });
  },
  setRoomType({ commit }, room_type) {
    return RoomTypeService.setRoomType(room_type).then(response => {
      if (response.error) throw new Error(response.error);
      commit("SET_ROOM_TYPE", response);
      return response;
    });
  },
  removeRoomType({ commit }, data) {
    return RoomTypeService.removeRoomType(data).then(response => {
      if (response.error) throw new Error(response.error);
      commit("DELETE_ROOM_TYPE", data.id);
      return response;
    });
  },
  highlightRoomType({ commit }, data) {
    return RoomTypeService.highlightRoomType(data).then(response => {
      if (response.error) throw new Error(response.error);
      commit("HIGHLIGHT_ROOM_TYPE", data);
      return response;
    });
  },
  setRoomTypePosition({ commit }, data) {
    return RoomTypeService.setRoomTypePosition(data).then(response => {
      if (response.error) throw new Error(response.error);
      return response;
    });
  },
  getRoomTypePeriods({ commit }, params) {
    return RoomTypeService.getRoomTypePeriods(params).then(response => {
      if (response.error) throw new Error(response.error);
      commit("SET_ROOM_RATE_PERIODS", {
        id: params.room_rate_id,
        data: response
      });
      return response;
    });
  },
  setRoomRatePeriods({ commit }, data) {
    return RoomTypeService.setRoomRatePeriods(data).then(response => {
      if (response.error) throw new Error(response.error);
      commit("SET_ROOM_RATE_PERIODS", {
        id: data.room_rate_id,
        data: response
      });
      return response;
    });
  },
  fetchRoomRateRefPeriod({ commit, rootGetters }, params) {
    commit("SET_ROOM_RATE_REF_PERIOD_STATUS", 1);

    if (!rootGetters.current_hotel || !rootGetters.current_hotel.id) {
      return null;
    }

    return RoomTypeService.getRoomRateRefPeriod({
      hotel_id: rootGetters.current_hotel.id,
      from_date: params.from_date,
      to_date: params.to_date
    }).then(response => {
      if (response.error) throw new Error(response.error);
      commit("SET_ROOM_RATE_REF_PERIOD", response.dates || []);
      commit("SET_ROOM_RATE_REF_PERIOD_STATUS", 2);
      return response;
    });
  },
  setRoomRateRefPeriod({ commit, dispatch }, data) {
    return RoomTypeService.setRoomRateRefPeriod(data).then(response => {
      if (response.error) throw new Error(response.error);
      // El backend només retorna recalc si de debò ha encolat feina.
      if (response.recalc) {
        commit("SET_REF_RECALC_JOB", {
          id: response.recalc.job_id,
          status: "pending",
          total_dates: response.recalc.total_dates,
          processed_dates: 0,
          changed_rates: 0,
          skipped_rates: 0,
          error_count: 0,
          progress: 0
        });
        dispatch("startRefRecalcPolling");
      }
      return response;
    });
  },
  fetchRefRecalcStatus({ commit, rootGetters }, job_id = null) {
    if (!rootGetters.current_hotel || !rootGetters.current_hotel.id) {
      return Promise.resolve(null);
    }
    const params = { hotel_id: rootGetters.current_hotel.id };
    if (job_id) {
      params.job_id = job_id;
    }
    return RoomTypeService.getRefRecalcStatus(params).then(response => {
      if (response.error) throw new Error(response.error);
      const job = response.job || null;
      commit("SET_REF_RECALC_JOB", job);
      return job;
    });
  },
  // Consulta l'estat del job fins que acaba. Viu al store (i no al component)
  // perquè el recàlcul continua encara que l'usuari canviï de pantalla.
  startRefRecalcPolling({ state, commit, dispatch }) {
    if (state.ref_recalc_polling) return;
    commit("SET_REF_RECALC_POLLING", true);

    const tick = () => {
      dispatch("fetchRefRecalcStatus")
        .then(job => {
          if (!job || REF_RECALC_FINAL_STATUSES.includes(job.status)) {
            dispatch("stopRefRecalcPolling");
          }
        })
        .catch(() => dispatch("stopRefRecalcPolling"));
    };

    ref_recalc_timer = setInterval(tick, REF_RECALC_POLL_MS);
    tick();
  },
  stopRefRecalcPolling({ commit }) {
    if (ref_recalc_timer) {
      clearInterval(ref_recalc_timer);
      ref_recalc_timer = null;
    }
    commit("SET_REF_RECALC_POLLING", false);
  },
  clearRefRecalcJob({ commit, dispatch }) {
    dispatch("stopRefRecalcPolling");
    commit("SET_REF_RECALC_JOB", null);
  }
};

export const getters = {
  refRecalcActive: state =>
    !!state.ref_recalc_job &&
    ["pending", "processing"].includes(state.ref_recalc_job.status),
  pmsRoomTypes: state => {
    return state.types_mapped.map(rt => {
      return {
        code: rt.pms_room_type_code ? rt.pms_room_type_code : rt.code,
        name: rt.name,
        highlighted: rt.highlighted,
        color: rt.color,
        available_rooms: rt.available_rooms
      };
    });
  },
  getRoomTypeById: state => id => {
    return state.types_mapped.find(rt => rt.id === id);
  }
};
